<template>
  <section class="wrapper">
    <div v-if="applyInfo.FormType==='FB'">
      <van-cell-group>
        <van-cell title="发起岗位" :value="applyInfo.Post"/>
        <van-cell title="申请人" :value="applyInfo.ActApply"/>
        <van-cell title="摘要" :value="applyInfo.summary"/>
      </van-cell-group>
      <van-collapse v-model="activeFollow">
        <van-collapse-item :title="`报销明细${index+1}`" :name="index" v-for="(detail,index) in applyInfo.details"
                           :key="index">
          <van-cell-group>
            <van-cell title="负担部门" :value="fomatterOrganizationInfo(detail.OrganizationInfo)"/>
            <van-cell title="发生日期" :value="moment(detail.EventDate).format('YYYY-MM-DD')"/>
            <van-cell title="详细类别" :value="detail.DetailInvName"/>
            <van-cell title="摘要" :value="detail.Remark"/>
            <van-cell title="供应商/交易方" :value="detail.RPerName"/>
          </van-cell-group>
          <van-collapse v-model="subFormName">
            <van-collapse-item title="VAT专票" :name="1">
              <van-cell title="税种" :value="detail.TaxationCategory"/>
              <van-cell title="税费" :value="detail.TaxationAmount"/>
              <van-cell title="含税金额" :value="detail.SumAmount"/>
              <van-cell title="货币" :value="detail.Currency"/>
            </van-collapse-item>
          </van-collapse>
        </van-collapse-item>
      </van-collapse>
      <van-row class="total">
        <van-col span="12" class="title">费用总金额</van-col>
        <van-col span="12" class="value"><small>{{applyInfo.Currency}}</small><i class="ml5 h4">{{applyInfo.ExpensesAmount}}</i></van-col>
      </van-row>
      <van-row class="total">
        <van-col span="12" class="title">补助总金额</van-col>
        <van-col span="12" class="value"><small>{{applyInfo.Currency}}</small><i class="ml5 h4">{{applyInfo.SubsidyAmount}}</i></van-col>
      </van-row>
      <van-divider :style="{ borderColor: '#f6f6f8', margin: '0' }"/>
      <van-row class="total">
        <van-col span="12" class="text-muted">报销总金额</van-col>
        <van-col span="12" class="value text-primary"><small class="ml5">合计 {{applyInfo.Currency}}</small><i class="ml5 h3 text-info">{{applyInfo.TotalAmount}}</i>
        </van-col>
      </van-row>
    </div>
    <div v-else-if="applyInfo.FormType==='FL'||applyInfo.FormType==='FW'">
    <van-cell-group>
      <van-cell title="发起岗位" :value="applyInfo.Post"/>
      <van-cell title="申请人" :value="applyInfo.ActApply"/>
      <van-cell title="摘要" :value="applyInfo.summary"/>
    </van-cell-group>
    <van-collapse v-model="activeFollow">
      <van-collapse-item :title="`${applyInfo.FormType==='FL'?'请假':applyInfo.FormType==='FW'?'加班':''}明细${index+1}`" :name="index" v-for="(detail,index) in applyInfo.details" :key="index">
        <van-cell-group>
          <van-cell :title="`${applyInfo.FormType==='FL'?'请假类别':applyInfo.FormType==='FW'?'加班结算方式':''}`" :value="detail.LeaveType"/>
          <van-cell title="开始日期" :value="detail.BeginDate"/>
          <van-cell title="结束日期" :value="detail.EndDate"/>
          <van-cell :title="`${applyInfo.FormType==='FL'?'请假':applyInfo.FormType==='FW'?'加班':''}事由`" :value="detail.Remark"/>
          <van-cell :title="`${applyInfo.FormType==='FL'?'请假':applyInfo.FormType==='FW'?'加班':''}时长`" :value="detail.SumLeave"/>
          <van-cell title="单位" :value="detail.LeaveTypeUnit"/>
        </van-cell-group>
      </van-collapse-item>
    </van-collapse>
  </div>
    <div v-else-if="applyInfo.FormType==='FT'">
      <van-cell-group>
        <van-cell title="发起岗位" :value="applyInfo.Post"/>
        <van-cell title="申请人" :value="applyInfo.ActApply"/>
        <van-cell title="摘要" :value="applyInfo.summary"/>
      </van-cell-group>
      <van-collapse v-model="activeFollow">
        <van-collapse-item title="出差" :name="index" v-for="(detail,index) in applyInfo.details" :key="index">
          <van-cell-group>
            <van-cell title="出差类别" :value="detail.LeaveType"/>
            <van-cell title="开始日期" :value="detail.BeginDate"/>
            <van-cell title="结束日期" :value="detail.EndDate"/>
            <van-cell title="始发地址" :value="detail.FromDestination"/>
            <van-cell title="目的地址" :value="detail.Destination"/>
            <van-cell title="目的地名称" :value="detail.LocationName"/>
            <van-cell title="出差事由" :value="detail.Remark"/>
            <van-cell title="出差时长" :value="detail.SumLeave"/>
            <van-cell title="单位" :value="detail.LeaveTypeUnit"/>
          </van-cell-group>
        </van-collapse-item>
      </van-collapse>
    </div>
    <div v-else-if="applyInfo.FormType==='FK'">
      <van-cell-group>
        <van-cell title="发起岗位" :value="applyInfo.Post"/>
        <van-cell title="申请人" :value="applyInfo.ActApply"/>
        <van-cell title="摘要" :value="applyInfo.summary"/>
      </van-cell-group>
      <van-collapse v-model="activeFollow">
        <van-collapse-item :title="`付款明细${index+1}`" :name="index" v-for="(detail,index) in applyInfo.details" :key="index">
            <van-cell-group>
                <van-cell title="日期" :value="detail.Date"/>
                <van-cell title="负担部门" :value="fomatterOrganizationInfo(detail.OrganizationInfo)"/>
                <van-cell title="收款单位" :value="detail.RPerName"/>
                <van-cell title="金额" :value="DecimalFormat(detail.SumAmount)"/>
                <van-cell title="货币" :value="detail.Currency"/>
                <van-cell title="付款类别" :value="detail.InvType"/>
                <van-cell title="付款子类" :value="detail.InvTypeDts"/>
                <van-cell title="付款详细类别" :value="detail.DetailInvType"/>
                <van-cell title="资金类别" :value="detail.PayCategory"/>
                <van-cell title="付款账户" :value="detail.DetailRPType"/>
                <van-cell title="备注" :value="detail.Remark"/>
                <van-cell title="销账状态" :value="detail.Record"/>
            </van-cell-group>
        </van-collapse-item>
      </van-collapse>
    </div>
    <div v-else-if="applyInfo.FormType==='FS'">
      <van-cell-group>
        <van-cell title="发起岗位" :value="applyInfo.Post"/>
        <van-cell title="申请人" :value="applyInfo.ActApply"/>
        <van-cell title="摘要" :value="applyInfo.summary"/>
      </van-cell-group>
      <van-collapse v-model="activeFollow">
        <van-collapse-item :title="`销售合同明细${index+1}`" :name="index" v-for="(detail,index) in applyInfo.details" :key="index">
          <van-cell-group>
            <van-cell title="交易名称/摘要" :value="detail.MM_Name"/>
            <van-cell title="单位" :value="detail.Unit"/>
            <van-cell title="数量" :value="detail.Number"/>
            <van-cell title="不含税单价" :value="detail.UnitPrice"/>
            <van-cell title="不含税金额" :value="DecimalFormat(detail.Amount)"/>
            <van-cell title="发票类别" :value="detail.Category"/>
            <van-cell title="税率" :value="detail.TaxationName"/>
            <van-cell title="含税单价" :value="detail.TaxUnitPrice"/>
            <van-cell title="含税金额" :value="DecimalFormat(detail.SumAmount)"/>
            <van-cell title="货币" :value="detail.Currency"/>
            <van-cell title="交付日期" :value="detail.Remark!=null&&detail.Remark.indexOf('期初')>-1?'起始':moment(detail.ReceiptDate).format('YYYY/MM/DD')"/>
            <van-cell title="备注" :value="detail.Remark"/>
            <van-cell title="待交付数量" :value="detail.DisPlanNumber"/>
            <van-cell title="待开票金额" :value="DecimalFormat(detail.DisEntryAmount)"/>
          </van-cell-group>
        </van-collapse-item>
      </van-collapse>
    </div>
    <div v-else-if="applyInfo.FormType==='FO'">
      <van-cell-group>
        <van-cell title="发起岗位" :value="applyInfo.Post"/>
        <van-cell title="申请人" :value="applyInfo.ActApply"/>
        <van-cell title="摘要" :value="applyInfo.summary"/>
      </van-cell-group>
      <van-collapse v-model="activeFollow">
        <van-collapse-item :title="`客户订单明细${index+1}`" :name="index" v-for="(detail,index) in applyInfo.details" :key="index">
          <van-cell-group>
            <van-cell title="交易名称/摘要" :value="detail.MM_Name"/>
            <van-cell title="不含税单价" :value="detail.UnitPrice"/>
            <van-cell title="不含税金额" :value="DecimalFormat(detail.Amount)"/>
            <van-cell title="发票类别" :value="detail.Category"/>
            <van-cell title="税率" :value="detail.TaxationName"/>
            <van-cell title="含税单价" :value="detail.TaxUnitPrice"/>
            <van-cell title="含税金额" :value="DecimalFormat(detail.SumAmount)"/>
            <van-cell title="货币" :value="detail.Currency"/>
            <van-cell title="交付日期" :value="detail.Remark!=null&&detail.Remark.indexOf('期初')>-1?'起始':moment(detail.ReceiptDate).format('YYYY/MM/DD')"/>
            <van-cell title="备注" :value="detail.Remark"/>
            <van-cell title="待交付数量" :value="detail.DisPlanNumber"/>
            <van-cell title="待开票金额" :value="DecimalFormat(detail.DisEntryAmount)"/>
          </van-cell-group>
        </van-collapse-item>
      </van-collapse>
    </div>
    <div v-else-if="applyInfo.FormType==='FA'||applyInfo.FormType==='FD'">
      <van-cell-group>
        <van-cell title="发起岗位" :value="applyInfo.Post"/>
        <van-cell title="申请人" :value="applyInfo.ActApply"/>
        <van-cell title="摘要" :value="applyInfo.summary"/>
      </van-cell-group>
      <van-collapse v-model="activeFollow">
        <van-collapse-item :title="`${applyInfo.FormType==='FA'?'采购合同':applyInfo.FormType==='FD'?'采购订单':''}明细${index+1}`" :name="index" v-for="(detail,index) in applyInfo.details" :key="index">
          <van-cell-group>
            <van-cell title="采购类别" :value="detail.InvType"/>
            <van-cell title="科目" :value="detail.GE_Name"/>
            <van-cell title="交易商品/服务" :value="detail.MM_Name"/>
            <van-cell title="品牌" :value="detail.Brand"/>
            <van-cell title="型号" :value="detail.MaterialNo"/>
            <van-cell title="规格" :value="detail.Model"/>
            <van-cell title="单位" :value="detail.Unit"/>
            <van-cell title="数量" :value="detail.Number"/>
            <van-cell title="不含税单价" :value="detail.UnitPrice"/>
            <van-cell title="不含税金额" :value="DecimalFormat(detail.Amount)"/>
            <van-cell title="发票类别" :value="detail.Category"/>
            <van-cell title="税率" :value="detail.TaxationName"/>
            <van-cell title="含税单价" :value="detail.TaxUnitPrice"/>
            <van-cell title="含税金额" :value="DecimalFormat(detail.SumAmount)"/>
            <van-cell title="货币" :value="detail.Currency"/>
            <van-cell title="交货日期" :value="detail.Remark!=null&&detail.Remark.indexOf('期初')>-1?'起始':moment(detail.ReceiptDate).format('YYYY/MM/DD')"/>
            <van-cell title="备注" :value="detail.Remark"/>
            <van-cell title="待接收数量" :value="detail.DisRecNumber"/>
            <van-cell title="待结算金额" :value="DecimalFormat(detail.DisEntryAmount)"/>
          </van-cell-group>
        </van-collapse-item>
      </van-collapse>
    </div>
    <div v-else-if="applyInfo.FormType==='FH'">
      <van-cell-group>
        <van-cell title="发起岗位" :value="applyInfo.Post"/>
        <van-cell title="申请人" :value="applyInfo.ActApply"/>
        <van-cell title="薪资周期" :value="applyInfo.summary"/>
      </van-cell-group>
      <van-collapse v-model="activeFollow">
        <van-collapse-item :title="`员工薪酬明细${index+1}`" :name="index" v-for="(detail,index) in applyInfo.details" :key="index">
          <van-collapse v-model="subFormName">
            <van-collapse-item :title="detail.SalaryList.filter(o=>o.TypeOrderNum==1)[0].Type" name="1">
              <van-cell :title="value.Name" :value="value.Name=='成本归属'?detail.InvType:value.Inf" v-for="(value,i) in detail.SalaryList.filter(o=>o.TypeOrderNum==1)" :key="i"/>
            </van-collapse-item>
            <van-collapse-item :title="detail.SalaryList.filter(o=>o.TypeOrderNum==2)[0].Type" name="2">
              <van-cell :title="value.Name" :value="value.SalaryAmount" v-for="(value,i) in detail.SalaryList.filter(o=>o.TypeOrderNum==2)" :key="i"/>
            </van-collapse-item>
            <van-collapse-item :title="detail.SalaryList.filter(o=>o.TypeOrderNum==3)[0].Type" name="3">
              <van-cell :title="value.Name" :value="value.SalaryAmount" v-for="(value,i) in detail.SalaryList.filter(o=>o.TypeOrderNum==3)" :key="i"/>
            </van-collapse-item>
          </van-collapse>
          <van-cell-group>
          <van-cell :title="detail.SalaryList.filter(o=>o.TypeOrderNum==4)[0].Type":value="detail.SalaryList.filter(o=>o.TypeOrderNum==4)[0].SalaryAmount"/>
          </van-cell-group>
          <van-collapse v-model="subFormName">
            <van-collapse-item :title="detail.SalaryList.filter(o=>o.TypeOrderNum==5)[0].Type" name="5">
              <van-cell :title="value.Name" :value="value.SalaryAmount" v-for="(value,i) in detail.SalaryList.filter(o=>o.TypeOrderNum==5)" :key="i"/>
            </van-collapse-item>
          </van-collapse>
          <van-cell-group>
            <van-cell :title="detail.SalaryList.filter(o=>o.TypeOrderNum==6)[0].Type" :value="detail.SalaryList.filter(o=>o.TypeOrderNum==6)[0].SalaryAmount"/>
          </van-cell-group>
        </van-collapse-item>
        <van-divider :style="{ borderColor: '#f6f6f8', margin: '0' }"/>
        <van-collapse-item title="查询合计" style="font-weight:bold">
          <van-collapse v-model="subFormName">
              <van-cell :title="`${detail.Name}总费用`" :value="detail.SumSalaryAmount" v-for="(detail,index) in SalaryTotalList" :key="index"/>
          </van-collapse>
        </van-collapse-item>
      </van-collapse>
    </div>
    <div v-else-if="applyInfo.FormType==='FI'">
      <van-cell-group>
        <van-cell title="发起岗位" :value="applyInfo.Post"/>
        <van-cell title="申请人" :value="applyInfo.ActApply"/>
        <van-cell title="摘要" :value="applyInfo.summary"/>
      </van-cell-group>
      <van-collapse v-model="activeFollow">
        <van-collapse-item :title="`借款/预付款申请明细${index+1}`" :name="index" v-for="(detail,index) in applyInfo.details" :key="index">
          <van-cell-group>
            <van-cell title="申请日期" :value="detail.EventDate"/>
            <van-cell title="负担组织" :value="fomatterOrganizationInfo(detail.OrganizationInfo)"/>
            <van-cell title="申请事由" :value="detail.ApplyReason"/>
            <van-cell title="申请金额" :value="DecimalFormat(detail.Amount)"/>
            <van-cell title="货币" :value="detail.Currency"/>
            <van-cell title="收款方式" :value="detail.PaymentMethod"/>
            <van-cell title="收款方" :value="detail.RPerName"/>
            <van-cell title="收款银行" :value="detail.PaymentBank"/>
            <van-cell title="银行账号" :value="detail.BankNo"/>
            <van-cell title="备注" :value="detail.Remark"/>
          </van-cell-group>
        </van-collapse-item>
      </van-collapse>
    </div>
    <div v-else-if="applyInfo.FormType==='FN'">
      <van-cell-group>
        <van-cell title="发起岗位" :value="applyInfo.Post"/>
        <van-cell title="申请人" :value="applyInfo.ActApply"/>
        <van-cell title="摘要" :value="applyInfo.summary"/>
      </van-cell-group>
      <van-collapse v-model="activeFollow">
        <van-collapse-item :title="`费用申请明细${index+1}`" :name="index" v-for="(detail,index) in applyInfo.details" :key="index">
          <van-cell-group>
            <van-cell title="发生日期" :value="detail.HappenDate!=undefined&&detail.HappenDate!=null?moment(detail.HappenDate).format('YYYY-MM-DD'):''"/>
            <van-cell title="确认日期" :value="detail.AffirmDate!=undefined&&detail.AffirmDate!=null?moment(detail.AffirmDate).format('YYYY-MM-DD'):''"/>
            <van-cell title="截止日期" :value="detail.Date!=undefined&&detail.Date!=null?moment(detail.Date).format('YYYY-MM-DD'):''"/>
            <van-cell title="供应商" :value="RPerFmter(detail.RPerName,detail)"/>
            <van-cell title="摘要" :value="detail.orderName"/>
            <van-cell title="发票" :value="detail.InvNo"/>
            <van-cell title="不含税金额" :value="DecimalFormat(detail.DomesticAmount)"/>
            <van-cell title="税费" :value="DecimalFormat(detail.TaxdomesticAmount)"/>
            <van-cell title="总金额" :value="DecimalFormat(detail.DomesticSumAmount)"/>
            <van-cell title="货币" :value="detail.CompanyCurrency"/>
            <van-cell title="费用类别" :value="detail.InvType"/>
            <van-cell title="详细类别" :value="detail.IEGroup"/>
            <van-cell title="负担部门" :value="fomatterOrganizationInfo(detail.OrganizationInfo)"/>
            <van-cell title="状态" :value="detail.IsAPProve==='1'?'未付':detail.State"/>
          </van-cell-group>
        </van-collapse-item>
      </van-collapse>
    </div>
    <div v-else-if="applyInfo.FormType==='FF'">
      <van-cell-group>
        <van-cell title="发起岗位" :value="applyInfo.Post"/>
        <van-cell title="申请人" :value="applyInfo.ActApply"/>
        <van-cell title="摘要" :value="applyInfo.summary"/>
      </van-cell-group>
      <van-collapse v-model="activeFollow">
        <van-collapse-item :title="`入职员工明细${index+1}`" :name="index" v-for="(detail,index) in applyInfo.details" :key="index">
          <van-collapse-item title="员工个人信息" name="1">
            <van-field input-align="right" label="头像">
              <template #input v-if="detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='头像')!==null&&PersonColumnList.filter(o=>o.Name==='头像').length>0?PersonColumnList.filter(o=>o.Name==='头像')[0].GUID:''))!==null&&detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='头像')!==null&&PersonColumnList.filter(o=>o.Name==='头像').length>0?PersonColumnList.filter(o=>o.Name==='头像')[0].GUID:'')).length>0">
                <img :src="detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='头像')!==null&&PersonColumnList.filter(o=>o.Name==='头像').length>0?PersonColumnList.filter(o=>o.Name==='头像')[0].GUID:''))[0].Inf" alt="头像"/>
              </template>
              <template #input v-else>
                <img src="../../assets/img/touPhotn.png" alt="头像" />
              </template>
            </van-field>
            <van-cell title="姓名" :value="detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='姓名')!==null&&PersonColumnList.filter(o=>o.Name==='姓名').length>0?PersonColumnList.filter(o=>o.Name==='姓名')[0].GUID:''))!==null&&detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='姓名')!==null&&PersonColumnList.filter(o=>o.Name==='姓名').length>0?PersonColumnList.filter(o=>o.Name==='姓名')[0].GUID:'')).length>0?detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='姓名')!==null&&PersonColumnList.filter(o=>o.Name==='姓名').length>0?PersonColumnList.filter(o=>o.Name==='姓名')[0].GUID:''))[0].Inf:''"/>
            <van-cell title="英文姓" :value="detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='英文姓')!==null&&PersonColumnList.filter(o=>o.Name==='英文姓').length>0?PersonColumnList.filter(o=>o.Name==='英文姓')[0].GUID:''))!==null&&detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='英文姓')!==null&&PersonColumnList.filter(o=>o.Name==='英文姓').length>0?PersonColumnList.filter(o=>o.Name==='英文姓')[0].GUID:'')).length>0?detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='英文姓')!==null&&PersonColumnList.filter(o=>o.Name==='英文姓').length>0?PersonColumnList.filter(o=>o.Name==='英文姓')[0].GUID:''))[0].Inf:''"/>
            <van-cell title="英文名" :value="detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='英文名')!==null&&PersonColumnList.filter(o=>o.Name==='英文姓').length>0?PersonColumnList.filter(o=>o.Name==='英文名')[0].GUID:''))!==null&&detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='英文名')!==null&&PersonColumnList.filter(o=>o.Name==='英文姓').length>0?PersonColumnList.filter(o=>o.Name==='英文名')[0].GUID:'')).length>0?detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='英文名')!==null&&PersonColumnList.filter(o=>o.Name==='英文姓').length>0?PersonColumnList.filter(o=>o.Name==='英文名')[0].GUID:''))[0].Inf:''"/>
            <van-cell title="出生日期" :value="detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='出生日期')!==null&&PersonColumnList.filter(o=>o.Name==='出生日期').length>0?PersonColumnList.filter(o=>o.Name==='出生日期')[0].GUID:''))!==null&&detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='出生日期')!==null&&PersonColumnList.filter(o=>o.Name==='出生日期').length>0?PersonColumnList.filter(o=>o.Name==='出生日期')[0].GUID:'')).length>0?detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='出生日期')!==null&&PersonColumnList.filter(o=>o.Name==='出生日期').length>0?PersonColumnList.filter(o=>o.Name==='出生日期')[0].GUID:''))[0].Inf:''"/>
            <van-cell title="其它名/昵称" :value="detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='其它名/昵称')!==null&&PersonColumnList.filter(o=>o.Name==='其它名/昵称').length>0?PersonColumnList.filter(o=>o.Name==='其它名/昵称')[0].GUID:''))!==null&&detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='其它名/昵称')!==null&&PersonColumnList.filter(o=>o.Name==='其它名/昵称').length>0?PersonColumnList.filter(o=>o.Name==='其它名/昵称')[0].GUID:'')).length>0?detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='其它名/昵称')!==null&&PersonColumnList.filter(o=>o.Name==='其它名/昵称').length>0?PersonColumnList.filter(o=>o.Name==='其它名/昵称')[0].GUID:''))[0].Inf:''"/>
            <van-cell title="性别" :value="detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='性别')!==null&&PersonColumnList.filter(o=>o.Name==='性别').length>0?PersonColumnList.filter(o=>o.Name==='性别')[0].GUID:''))!==null&&detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='性别')!==null&&PersonColumnList.filter(o=>o.Name==='性别').length>0?PersonColumnList.filter(o=>o.Name==='性别')[0].GUID:'')).length>0?detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='性别')!==null&&PersonColumnList.filter(o=>o.Name==='性别').length>0?PersonColumnList.filter(o=>o.Name==='性别')[0].GUID:''))[0].Inf:''"/>
            <van-cell title="民族" :value="detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='民族')!==null&&PersonColumnList.filter(o=>o.Name==='民族').length>0?PersonColumnList.filter(o=>o.Name==='民族')[0].GUID:''))!==null&&detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='民族')!==null&&PersonColumnList.filter(o=>o.Name==='民族').length>0?PersonColumnList.filter(o=>o.Name==='民族')[0].GUID:'')).length>0?detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='民族')!==null&&PersonColumnList.filter(o=>o.Name==='民族').length>0?PersonColumnList.filter(o=>o.Name==='民族')[0].GUID:''))[0].Inf:''"/>
            <van-cell title="出生国家" :value="detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='出生国家')!==null&&PersonColumnList.filter(o=>o.Name==='出生国家').length>0?PersonColumnList.filter(o=>o.Name==='出生国家')[0].GUID:''))!==null&&detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='出生国家')!==null&&PersonColumnList.filter(o=>o.Name==='出生国家').length>0?PersonColumnList.filter(o=>o.Name==='出生国家')[0].GUID:'')).length>0?detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='出生国家')!==null&&PersonColumnList.filter(o=>o.Name==='出生国家').length>0?PersonColumnList.filter(o=>o.Name==='出生国家')[0].GUID:''))[0].Inf:''"/>
            <van-cell title="家庭住址" :value="detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='家庭住址')!==null&&PersonColumnList.filter(o=>o.Name==='家庭住址').length>0?PersonColumnList.filter(o=>o.Name==='家庭住址')[0].GUID:''))!==null&&detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='家庭住址')!==null&&PersonColumnList.filter(o=>o.Name==='家庭住址').length>0?PersonColumnList.filter(o=>o.Name==='家庭住址')[0].GUID:'')).length>0?detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='家庭住址')!==null&&PersonColumnList.filter(o=>o.Name==='家庭住址').length>0?PersonColumnList.filter(o=>o.Name==='家庭住址')[0].GUID:''))[0].Inf:''"/>
            <van-cell title="证件名称" :value="detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='证件名称')!==null&&PersonColumnList.filter(o=>o.Name==='证件名称').length>0?PersonColumnList.filter(o=>o.Name==='证件名称')[0].GUID:''))!==null&&detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='证件名称')!==null&&PersonColumnList.filter(o=>o.Name==='证件名称').length>0?PersonColumnList.filter(o=>o.Name==='证件名称')[0].GUID:'')).length>0?detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='证件名称')!==null&&PersonColumnList.filter(o=>o.Name==='证件名称').length>0?PersonColumnList.filter(o=>o.Name==='证件名称')[0].GUID:''))[0].Inf:''"/>
            <van-cell title="证件号码" :value="detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='证件号码')!==null&&PersonColumnList.filter(o=>o.Name==='证件号码').length>0?PersonColumnList.filter(o=>o.Name==='证件号码')[0].GUID:''))!==null&&detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='证件号码')!==null&&PersonColumnList.filter(o=>o.Name==='证件号码').length>0?PersonColumnList.filter(o=>o.Name==='证件号码')[0].GUID:'')).length>0?detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='证件号码')!==null&&PersonColumnList.filter(o=>o.Name==='证件号码').length>0?PersonColumnList.filter(o=>o.Name==='证件号码')[0].GUID:''))[0].Inf:''"/>
            <van-cell title="手机区号" :value="detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='手机区号')!==null&&PersonColumnList.filter(o=>o.Name==='手机区号').length>0?PersonColumnList.filter(o=>o.Name==='手机区号')[0].GUID:''))!==null&&detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='手机区号')!==null&&PersonColumnList.filter(o=>o.Name==='手机区号').length>0?PersonColumnList.filter(o=>o.Name==='手机区号')[0].GUID:'')).length>0?detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='手机区号')!==null&&PersonColumnList.filter(o=>o.Name==='手机区号').length>0?PersonColumnList.filter(o=>o.Name==='手机区号')[0].GUID:''))[0].Inf:''"/>
            <van-cell title="手机号" :value="detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='手机号')!==null&&PersonColumnList.filter(o=>o.Name==='手机号').length>0?PersonColumnList.filter(o=>o.Name==='手机号')[0].GUID:''))!==null&&detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='手机号')!==null&&PersonColumnList.filter(o=>o.Name==='手机号').length>0?PersonColumnList.filter(o=>o.Name==='手机号')[0].GUID:'')).length>0?detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='手机号')!==null&&PersonColumnList.filter(o=>o.Name==='手机号').length>0?PersonColumnList.filter(o=>o.Name==='手机号')[0].GUID:''))[0].Inf:''"/>
            <van-cell title="个人邮箱" :value="detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='个人邮箱')!==null&&PersonColumnList.filter(o=>o.Name==='个人邮箱').length>0?PersonColumnList.filter(o=>o.Name==='个人邮箱')[0].GUID:''))!==null&&detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='个人邮箱')!==null&&PersonColumnList.filter(o=>o.Name==='个人邮箱').length>0?PersonColumnList.filter(o=>o.Name==='个人邮箱')[0].GUID:'')).length>0?detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='个人邮箱')!==null&&PersonColumnList.filter(o=>o.Name==='个人邮箱').length>0?PersonColumnList.filter(o=>o.Name==='个人邮箱')[0].GUID:''))[0].Inf:''"/>
            <van-cell title="最高学位" :value="detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='最高学位')!==null&&PersonColumnList.filter(o=>o.Name==='最高学位').length>0?PersonColumnList.filter(o=>o.Name==='最高学位')[0].GUID:''))!==null&&detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='最高学位')!==null&&PersonColumnList.filter(o=>o.Name==='最高学位').length>0?PersonColumnList.filter(o=>o.Name==='最高学位')[0].GUID:'')).length>0?detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='最高学位')!==null&&PersonColumnList.filter(o=>o.Name==='最高学位').length>0?PersonColumnList.filter(o=>o.Name==='最高学位')[0].GUID:''))[0].Inf:''"/>
            <van-cell title="现在住址" :value="detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='现在住址')!==null&&PersonColumnList.filter(o=>o.Name==='现在住址').length>0?PersonColumnList.filter(o=>o.Name==='现在住址')[0].GUID:''))!==null&&detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='现在住址')!==null&&PersonColumnList.filter(o=>o.Name==='现在住址').length>0?PersonColumnList.filter(o=>o.Name==='现在住址')[0].GUID:'')).length>0?detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='现在住址')!==null&&PersonColumnList.filter(o=>o.Name==='现在住址').length>0?PersonColumnList.filter(o=>o.Name==='现在住址')[0].GUID:''))[0].Inf:''"/>
            <van-cell title="紧急联系人" :value="detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='紧急联系人')!==null&&PersonColumnList.filter(o=>o.Name==='紧急联系人').length>0?PersonColumnList.filter(o=>o.Name==='紧急联系人')[0].GUID:''))!==null&&detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='紧急联系人')!==null&&PersonColumnList.filter(o=>o.Name==='紧急联系人').length>0?PersonColumnList.filter(o=>o.Name==='紧急联系人')[0].GUID:'')).length>0?detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='紧急联系人')!==null&&PersonColumnList.filter(o=>o.Name==='紧急联系人').length>0?PersonColumnList.filter(o=>o.Name==='紧急联系人')[0].GUID:''))[0].Inf:''"/>
            <van-cell title="紧急联系人电话" :value="detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='紧急联系人电话')!==null&&PersonColumnList.filter(o=>o.Name==='紧急联系人电话').length>0?PersonColumnList.filter(o=>o.Name==='紧急联系人电话')[0].GUID:''))!==null&&detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='紧急联系人电话')!==null&&PersonColumnList.filter(o=>o.Name==='紧急联系人电话').length>0?PersonColumnList.filter(o=>o.Name==='紧急联系人电话')[0].GUID:'')).length>0?detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='紧急联系人电话')!==null&&PersonColumnList.filter(o=>o.Name==='紧急联系人电话').length>0?PersonColumnList.filter(o=>o.Name==='紧急联系人电话')[0].GUID:''))[0].Inf:''"/>
          </van-collapse-item>
          <van-collapse-item title="员工在职信息" name="2">
            <van-cell title="入职日期" :value="detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='入职日期')!==null&&PersonColumnList.filter(o=>o.Name==='入职日期').length>0?PersonColumnList.filter(o=>o.Name==='入职日期')[0].GUID:''))!==null&&detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='入职日期')!==null&&PersonColumnList.filter(o=>o.Name==='入职日期').length>0?PersonColumnList.filter(o=>o.Name==='入职日期')[0].GUID:'')).length>0?detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='入职日期')!==null&&PersonColumnList.filter(o=>o.Name==='入职日期').length>0?PersonColumnList.filter(o=>o.Name==='入职日期')[0].GUID:''))[0].Inf:''"/>
            <van-cell title="工号" :value="detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='工号')!==null&&PersonColumnList.filter(o=>o.Name==='工号').length>0?PersonColumnList.filter(o=>o.Name==='工号')[0].GUID:''))!==null&&detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='工号')!==null&&PersonColumnList.filter(o=>o.Name==='工号').length>0?PersonColumnList.filter(o=>o.Name==='工号')[0].GUID:'')).length>0?detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='工号')!==null&&PersonColumnList.filter(o=>o.Name==='工号').length>0?PersonColumnList.filter(o=>o.Name==='工号')[0].GUID:''))[0].Inf:''"/>
            <van-cell title="部门" :value="detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='部门')!==null&&PersonColumnList.filter(o=>o.Name==='部门').length>0?PersonColumnList.filter(o=>o.Name==='部门')[0].GUID:''))!==null&&detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='部门')!==null&&PersonColumnList.filter(o=>o.Name==='部门').length>0?PersonColumnList.filter(o=>o.Name==='部门')[0].GUID:'')).length>0?detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='部门')!==null&&PersonColumnList.filter(o=>o.Name==='部门').length>0?PersonColumnList.filter(o=>o.Name==='部门')[0].GUID:''))[0].Inf:''"/>
            <van-cell title="岗位" :value="detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='岗位')!==null&&PersonColumnList.filter(o=>o.Name==='岗位').length>0?PersonColumnList.filter(o=>o.Name==='岗位')[0].GUID:''))!==null&&detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='岗位')!==null&&PersonColumnList.filter(o=>o.Name==='岗位').length>0?PersonColumnList.filter(o=>o.Name==='岗位')[0].GUID:'')).length>0?detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='岗位')!==null&&PersonColumnList.filter(o=>o.Name==='岗位').length>0?PersonColumnList.filter(o=>o.Name==='岗位')[0].GUID:''))[0].Inf:''"/>
            <van-cell title="头衔" :value="detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='头衔')!==null&&PersonColumnList.filter(o=>o.Name==='头衔').length>0?PersonColumnList.filter(o=>o.Name==='头衔')[0].GUID:''))!==null&&detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='头衔')!==null&&PersonColumnList.filter(o=>o.Name==='头衔').length>0?PersonColumnList.filter(o=>o.Name==='头衔')[0].GUID:'')).length>0?detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='头衔')!==null&&PersonColumnList.filter(o=>o.Name==='头衔').length>0?PersonColumnList.filter(o=>o.Name==='头衔')[0].GUID:''))[0].Inf:''"/>
            <van-cell title="职级" :value="detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='职级')!==null&&PersonColumnList.filter(o=>o.Name==='职级').length>0?PersonColumnList.filter(o=>o.Name==='职级')[0].GUID:''))!==null&&detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='职级')!==null&&PersonColumnList.filter(o=>o.Name==='职级').length>0?PersonColumnList.filter(o=>o.Name==='职级')[0].GUID:'')).length>0?detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='职级')!==null&&PersonColumnList.filter(o=>o.Name==='职级').length>0?PersonColumnList.filter(o=>o.Name==='职级')[0].GUID:''))[0].Inf:''"/>
            <van-cell title="工作邮箱" :value="detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='工作邮箱')!==null&&PersonColumnList.filter(o=>o.Name==='工作邮箱').length>0?PersonColumnList.filter(o=>o.Name==='工作邮箱')[0].GUID:''))!==null&&detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='工作邮箱')!==null&&PersonColumnList.filter(o=>o.Name==='工作邮箱').length>0?PersonColumnList.filter(o=>o.Name==='工作邮箱')[0].GUID:'')).length>0?detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='工作邮箱')!==null&&PersonColumnList.filter(o=>o.Name==='工作邮箱').length>0?PersonColumnList.filter(o=>o.Name==='工作邮箱')[0].GUID:''))[0].Inf:''"/>
            <van-cell title="办公地点" :value="detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='办公地点')!==null&&PersonColumnList.filter(o=>o.Name==='办公地点').length>0?PersonColumnList.filter(o=>o.Name==='办公地点')[0].GUID:''))!==null&&detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='办公地点')!==null&&PersonColumnList.filter(o=>o.Name==='办公地点').length>0?PersonColumnList.filter(o=>o.Name==='办公地点')[0].GUID:'')).length>0?detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='办公地点')!==null&&PersonColumnList.filter(o=>o.Name==='办公地点').length>0?PersonColumnList.filter(o=>o.Name==='办公地点')[0].GUID:''))[0].Inf:''"/>
            <van-cell title="薪酬类别" :value="detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='薪酬类别')!==null&&PersonColumnList.filter(o=>o.Name==='薪酬类别').length>0?PersonColumnList.filter(o=>o.Name==='薪酬类别')[0].GUID:''))!==null&&detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='薪酬类别')!==null&&PersonColumnList.filter(o=>o.Name==='薪酬类别').length>0?PersonColumnList.filter(o=>o.Name==='薪酬类别')[0].GUID:'')).length>0?detail.PersonList.filter(o=>o.Col_GUID===(PersonColumnList.filter(o=>o.Name==='薪酬类别')!==null&&PersonColumnList.filter(o=>o.Name==='薪酬类别').length>0?PersonColumnList.filter(o=>o.Name==='薪酬类别')[0].GUID:''))[0].Inf:''"/>
          </van-collapse-item>
        </van-collapse-item>
      </van-collapse>
    </div>
    <div v-else-if="applyInfo.FormType==='FG'">
      <van-cell-group>
        <van-cell title="发起岗位" :value="applyInfo.Post"/>
        <van-cell title="申请人" :value="applyInfo.ActApply"/>
        <van-cell title="摘要" :value="applyInfo.summary"/>
      </van-cell-group>
      <van-collapse v-model="activeFollow">
        <van-collapse-item :title="`离职申请明细${index+1}`" :name="index" v-for="(detail,index) in applyInfo.details" :key="index">
          <van-cell-group>
            <van-cell title="姓名" :value="detail.Employee"/>
            <van-cell title="工号" :value="detail.StaffNumber"/>
            <van-cell title="离职日期" :value="moment(detail.LeaveDate).format('YYYY-MM-DD')"/>
            <van-cell title="离职原因" :value="detail.Inf"/>
            <van-cell title="具体原因" :value="detail.DetailInf"/>
          </van-cell-group>
        </van-collapse-item>
      </van-collapse>
    </div>
    <van-field
      v-model="applyInfo.appRemark"
      rows="1"
      :autosize="{minHeight: 150}"
      type="textarea"
      placeholder="请输入审批意见"
    />
    <div class="buttons">
      <van-button type="primary" v-show="applyInfo.Type==='1'" class="mr5" @click="submitAgreeForm">同意</van-button>
      <van-button type="primary" v-show="applyInfo.Type==='1'" plain class="mr5" @click="addSigner">加签</van-button>
      <van-button type="primary" v-show="applyInfo.Type==='1'" plain class="mr5" @click="submitRejectForm">拒绝</van-button>
      <van-button type="primary" plain @click="returnPage">返回</van-button>
    </div>
    <van-steps direction="vertical" :active="0" finish-icon="">
      <van-step v-for="(item,index) in followList" :key="index">
        <van-row>
          <van-col span="12" class="h4" :class="item.status?'text-muted':'text-lightgray'">
            <b>{{item.ApprovalNode}} {{item.ApprovalName}}</b>
          </van-col>
          <van-col span="12" class="text-right">
            <span :class="item.ClassName"><b>{{item.ApprovalStatus}}</b></span>
          </van-col>
        </van-row>
        <h5 class="opinion">{{item.Remark}}</h5>
        <h6 class="date">{{item.ApprovalDate}}</h6>
      </van-step>
    </van-steps>
  </section>
</template>

<script>
  import {getApplyFormInfoApi,getApprovalDetailApi,getWageCostByApprovalApi,getApprovalFFDetailApi,getApprovalFGDetailApi,getApprovalExpenseByGuidApi,getApprovalHistoryApi,submitAgreeFormApi,submitRejectFormApi} from '@/api/reimbursement'
  import {getPaymentListApi} from '@/api/payment'
  import {getSellContractWithDetailApi} from '@/api/sellmanage'
  import {getContractWithDetailsApi} from '@/api/purchasemanage'

  export default {
    data() {
      return {
        applyInfo: {
          FormType: '',//业务类型
          Taxpayer: '一般纳税人',//纳税人名称
          ActApply: '',//申请人
          Post: '',//发起岗位
          InvType: '',//费用类别
          summary: '',//摘要
          createDate: '',//日期
          details: [],//明细数据
          ExpensesAmount: '',//费用总金额
          SubsidyAmount: '',//补助总金额
          TotalAmount: '',//报销总金额
          appRemark: '',//审批意见
          Currency:'',//默认本位币
          Type:'1',//是否已审批 1-未审批，其它已审批
        },
        followList: [{
          ApprovalNode: '',//职务
          ApprovalName: '',//姓名
          ApprovalStatus: '审批中',//审批状态0待审批; 1已通过
          Remark: '',//审批意见
          ApprovalDate: '-',
          ClassName: 'text-danger'
        }],//审批流程列表
        processName:'',//业务明细名称
        activeFollow: [0],//当前显示的明细表单
        subFormName: [1],//当前显示第二级明细
        SalaryTotalList:[],//员工薪酬查询合计列表
        PersonColumnList:[],//员工列表字段
        approveGuid: this.$route.query.guid
      }
    },
    mounted() {
      this.getApplyFormInfo();
    },
    methods: {
      //获取审批表单数据
      async getApplyFormInfo() {
        if (this.approveGuid && this.approveGuid !== null && this.approvalGuid !== "") {
          let companyInfo = this.getCookie("CompanyInfo");
          let userInfo = this.getCookie("UserInfo");
          let params = {
            cGuid: companyInfo.companyId,
            uGuid: userInfo.U_GUID,
            guid: this.approveGuid//paramData.guid
          };
          let response = await getApplyFormInfoApi(params);
          if (response.success) {
            if (response.code === "0000") {
              if (response.result.Approval_GUID !== undefined && response.result.Approval_GUID !== null && response.result.Approval_GUID !== "") {
                this.$set(this.applyInfo, "Post", response.result.PostName);
                this.$set(this.applyInfo, "ActApply", response.result.ApplyName);
                this.$set(this.applyInfo, "InvType", response.result.InvType);
                this.$set(this.applyInfo, "FormType", response.result.FormType);
                this.$set(this.applyInfo, "summary", response.result.Remark);
                this.$set(this.applyInfo, "createDate", response.result.CreateDate);
                this.$set(this.applyInfo, "ExpensesAmount", response.result.ExpensesAmount);
                this.$set(this.applyInfo, "SubsidyAmount", response.result.SubsidyAmount);
                this.$set(this.applyInfo, "TotalAmount", response.result.Amount);
                this.$set(this.applyInfo, "Currency", (response.result.Currency===undefined||response.result.Currency===null||response.result.Currency===""? companyInfo.Currency:response.result.Currency));
                this.$set(this.applyInfo, "Type", response.result.Type);
                this.getApproveDetail();
                this.getApprovalHistory();
              }
              else{
                this.$router.push({path: '/approval/index'})
              }
            }
          }
        }
      },
      //获取审批明细数据
      async getApproveDetail() {
        if (this.approveGuid&&this.applyInfo.FormType) {
          let companyInfo = this.getCookie("CompanyInfo");
          //付款审批
          if (this.applyInfo.FormType === "FK") {
            let params = {
              cGuid: companyInfo.companyId,
              pageSize: 100,
              pageIndex: 1,
              record: '',
              dateBegin: '',
              dateEnd: '',
              customer: '',
              incomeGrp: '',
              InvTypeDts: '',
              rpGuid: this.approveGuid,
            };
            let response = await getPaymentListApi(params);
            if (response.success) {
              if (response.code === "0000") {
                this.applyInfo.details = response.result;
              }
            }
          }
          //销售合同、客户订单审批
          else if(this.applyInfo.FormType==="FS"||this.applyInfo.FormType==="FO"){
            let params = {
              cGuid: companyInfo.companyId,
              tcGuid:this.approveGuid,
              dateFormat: companyInfo.dateFormat,
            };
            let response = await getSellContractWithDetailApi(params);
            if (response.success) {
              if (response.code === "0000") {
                this.applyInfo.details = response.SellDetails;
              }
            }
          }
          //采购合同、采购订单审批
          else if(this.applyInfo.FormType==="FA"||this.applyInfo.FormType==="FD"){
            let params = {
              cGuid: companyInfo.companyId,
              orGuid:this.approveGuid,
              dateFormat: companyInfo.dateFormat,
            };
            let response = await getContractWithDetailsApi(params);
            if (response.success) {
              if (response.code === "0000") {
                this.applyInfo.details = response.OrderDetails;
              }
            }
          }
          //员工薪酬审批
          else if(this.applyInfo.FormType==="FH"){
            let params = {
              cGuid: companyInfo.companyId,
              approvalGuid:this.approveGuid,
            };
            let response = await getWageCostByApprovalApi(params);
            if (response.success) {
              if (response.code === "0000") {
                if (response.result != null && response.result.length > 0) {
                  this.applyInfo.details = response.result;
                  response.result[0].SalaryList.filter(o=>o.TypeOrderNum!="1").forEach((x, y) => {
                    let itemObject=new Object();
                    let sumSalaryAmount=0;
                    itemObject.Name=x.Name;
                    response.result.forEach((item,index)=>{
                        item.SalaryList.filter(o=>o.Name==x.Name).forEach((m, n) => {
                          sumSalaryAmount = this.addition(sumSalaryAmount, m.SalaryAmount);
                        });
                    });
                    itemObject.SumSalaryAmount=sumSalaryAmount;
                    this.SalaryTotalList.push(itemObject);
                  });
                }
              }
            }
          }
          //入职审批
          else if(this.applyInfo.FormType==="FF"){
            let params = {
              cGuid: companyInfo.companyId,
              approvalGuid:this.approveGuid,
            };
            let response = await getApprovalFFDetailApi(params);
            if (response.success) {
              if (response.code === "0000") {
                if (response.result != null && response.result.length > 0) {
                  this.applyInfo.details = response.result;
                  this.PersonColumnList = response.column;
                }
              }
            }
          }
          //离职审批
          else if(this.applyInfo.FormType==="FG"){
            let params = {
              cGuid: companyInfo.companyId,
              approvalGuid:this.approveGuid,
            };
            let response = await getApprovalFGDetailApi(params);
            if (response.success) {
              if (response.code === "0000") {
                if (response.result != null && response.result.length > 0) {
                  this.applyInfo.details = response.result;
                }
              }
            }
          }
          //费用申请审批
          else if(this.applyInfo.FormType==="FN"){
            let params = {
              cGuid: companyInfo.companyId,
              ieGuid:this.approveGuid
            };
            let response = await getApprovalExpenseByGuidApi(params);
            if (response.success) {
              if (response.code === "0000") {
                this.applyInfo.details = response.result;
              }
            }
          }
          //流程审批
          else {
            let params = {
              cGuid: companyInfo.companyId,
              guid: this.approveGuid,//paramData.guid,
              formType: this.applyInfo.FormType//paramData.formType
            };
            let response = await getApprovalDetailApi(params);
            if (response.success) {
              if (response.code === "0000") {
                if (response.result != null && response.result.length > 0) {
                  this.applyInfo.details = response.result;
                }
              }
            }
          }
        }
      },
      //将负担组织数据格式化处理
      fomatterOrganizationInfo(value) {
        if (!value || value === null || value === "") return "";
        try {
          let jsonArr = value.split(",");
          let str = "";
          let nameArr = new Array();
          for (let i = 0; i < jsonArr.length; i++) {
            let item = jsonArr[i].split(":");
            if (nameArr.filter(o => o.name == item[1]) === undefined || nameArr.filter(o => o.name == item[1]) === null || nameArr.filter(o => o.name == item[1]).length < 1) {
              str += !str || str === null || str === "" ? item[1] : ',' + item[1];
              var obj = new Object();
              obj.name = item[1];
              nameArr.push(obj);
            }
          }
          return str;
        } catch {
          return "";
        }
      },
      //获取审批历史流程
      async getApprovalHistory() {
        if (this.approveGuid) {
          let companyInfo = this.getCookie("CompanyInfo");
          let params = {
            cGuid: companyInfo.companyId,
            approvalGuid: this.approveGuid,// paramData.guid
          };
          let response = await getApprovalHistoryApi(params);
          if (response.success) {
            if (response.result && response.result.length) {
              this.followList.splice(0, 1);
              response.result.forEach((item, index) => {
                let isFlag = false;
                let formState = "审批中";
                let className = "text-danger";
                switch (item.ApprovalState) {
                  case "1":
                    isFlag = true;
                    formState = '已通过';
                    className = "text-primary";
                    break;
                  case "2":
                    isFlag = true;
                    formState = "已拒绝";
                    className = "text-danger";
                    break;
                  case "3":
                    isFlag = true;
                    formState = "审批结束";
                    className = "text-danger";
                    break;
                  case "4":
                    isFlag = true;
                    formState = "加签";
                    className = "text-danger";
                    break;
                  case "6":
                    isFlag = true;
                    formState = "提交";
                    className = "text-danger";
                    break;
                  case "7":
                    isFlag = true;
                    formState = "重新提交";
                    className = "text-danger";
                    break;
                  case "99":
                    isFlag = true;
                    formState = "代申请";
                    className = "text-danger";
                    break;
                  default:
                    break;
                }
                if (item.ApprovalState !== "99" && (item.IsAddFlag === "1" || item.IsAddFlag === "true")) {
                  if (item.ApprovalDate != null) {
                    isFlag = true;
                    formState = "加签返回";
                    className = "text-danger";
                  } else {
                    isFlag = false;
                    formState = "加签中";
                    className = "text-danger";
                  }
                }
                this.followList.push({
                  ApprovalNode: item.ApprovalNode,
                  ApprovalName: item.ApprovalName,
                  ApprovalDate: item.ApprovalDate == null ? '-' : item.ApprovalDate,
                  ApprovalStatus: formState,
                  Remark: isFlag ? "审批意见：" + item.Remark : "",
                  ClassName: className//样式名
                })
              })
            }
          }
        }
      },
      //审批通过
      async submitAgreeForm() {
        if (!this.approveGuid) {
          this.$toast.fail("审批数据不能为空");
          return;
        }
        let companyInfo = this.getCookie("CompanyInfo");
        let userInfo = this.getCookie("UserInfo");
        let params = {
          cGuid: companyInfo.companyId,
          companyName: companyInfo.companyName,
          uGuid: userInfo.U_GUID,
          loginName: userInfo.TelName || userInfo.LoginName,
          nickName:userInfo.NickName||userInfo.FirstName+userInfo.LastName,
          Remark: this.applyInfo.appRemark,
          approvalGuids: this.approveGuid
        };
        let response = await submitAgreeFormApi(params);
        if (response.success) {
          if (response.code === "0000") {
            this.$toast.success(response.msg);
            this.$router.push({path: '/approval/index'});
            return;
          }
          this.$toast.fail(response.msg);
          // return;
        }
      },
      //加签
      addSigner() {
        this.$router.push({
          path: '/approval/countersign', query: {
            guid: this.approveGuid
          }
        })
      },
      //审批拒绝
      async submitRejectForm() {
        if (!this.approveGuid) {
          this.$toast.fail("审批数据不能为空");
          return;
        }
        let companyInfo = this.getCookie("CompanyInfo");
        let userInfo = this.getCookie("UserInfo");
        let params = {
          cGuid: companyInfo.companyId,
          uGuid: userInfo.U_GUID,
          companyName: companyInfo.companyName,
          Remark: this.applyInfo.appRemark,
          approvalGuids: this.approveGuid
        };
        let response = await submitRejectFormApi(params);
        if (response.success) {
          if (response.code === "0000") {
            this.$toast.success(response.msg);
            this.$router.push({path: '/approval/index'});
            return;
          }
          this.$toast.fail(response.msg);
          return;
        }
      },
      //供应商格式化
      RPerFmter(value, row) {
        let linkf
        if (value === "-") {
          linkf = "（无明确交易方）";
        } else if (value===null){
          linkf = "";
        }else {
          linkf = value;
        }

        if (value === "-" &&(row.DetailInvType == "个人所得税" || row.InvTypeDts == "支付职工薪酬")) {
          linkf = row.EName && row.EName != "员工" ? row.EName : "员工";
        }
        return linkf;
      },
      //返回
      returnPage() {
        let flag = localStorage.getItem("ApproveFlag");
        if (flag == 1) {
          this.$router.push({
            path: '/follow'
          })
        } else {
          this.$router.push({
            path: '/approval/index'
          })
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .wrapper {
    height: calc(100vh - 5rem);

    .add-detail {
      color: #0066ff;
      text-align: center;
      padding: 1rem 0;
      font-size: 1.4rem;
    }

    ::v-deep.van-collapse-item__content {
      padding: 0;
    }

    ::v-deep.van-collapse-item__title {
      background: #f6f6f8;
    }

    .total {
      padding: 1rem;
      background: #f6f6f8;
      font-size: 14px;
      .title {
        color: #bababb;
        font-size: 14px;
      }

      .value {
        color: #323332;
        text-align: right;
        font-size: 14px;
      }
      .text-muted{
        font-size: 14px;
      }
    }

    .buttons {
      margin: 1rem;
      display: flex;

      button {
        border-radius: 1rem;
        flex: 1;
      }
    }

    .opinion {
      margin-top: 1rem;
      color: #979797;
      word-break: break-all;
    }

    .date {
      color: #b7b7b7;
      text-align: right;
    }
    .van-field__control--custom {
      img {
        width: 4vh;
      }
    }
  }
</style>
